
'use strict';

require('../user/UserService.js');

function UsersResetPasswordCtrl(
  $scope,
  UserService,
  translations,
  $stateParams,
  $state,
  $http,
  config,
  growl
) {

  $http({
    method: 'GET',
    url: config.apiBase + '/users/'+$stateParams.userId+'/reset-password?code='+encodeURIComponent($stateParams.code)
  })
  .success(function() {
    $scope.password = "";
    $scope.retypePassword = "";
  })
  .error(function(resp) {
    if(resp.error.code !== 200){
      window.location.href = '/login';
    }
  });
  
  $scope.setPassword = function() {
    $http({
      method: 'POST',
      url: config.apiBase + '/users/'+$stateParams.userId+'/reset-password?code='+encodeURIComponent($stateParams.code),
      data: {password: $scope.password},
      transformRequest: function(obj) {
        var str = [];
        angular.forEach(obj, function(v, k){
          str.push(encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]));
        });
        return str.join("&");
      },
      headers: {"Content-Type": "application/x-www-form-urlencoded"}
    })
    .success(function() {
      growl.addSuccessMessage(translations['user.password-reset-success']);
      window.location.href = '/login';
    })
    .error(function() {
      growl.addErrorMessage(translations['user.password-reset-failure']);
    });
  };
}

UsersResetPasswordCtrl.resolve = {
  translations: ['$translate', function($translate) {
    return $translate([
      'user.password-reset-success',
      'user.password-reset-failure'
    ]);
  }]
};

module.exports = UsersResetPasswordCtrl;

angular.module('dokiv')
  .controller('UsersResetPasswordCtrl', [
    '$scope',
    'UserService',
    'translations',
    '$stateParams',
    '$state',
    '$http',
    'config',
    'growl',
    UsersResetPasswordCtrl
  ]);




//////////////////
// WEBPACK FOOTER
// ./scripts/auth/UsersResetPasswordCtrl.js
// module id = 279
// module chunks = 0